import React from 'react';

import { TableCellDescriptions } from '../../components/TableCellDescriptions';
import {
  getVendorPasscodesDocument,
  getVendorPasscodesTotalDocument,
  VendorPasscodeTableFragment,
  VendorPasscodeTableFragmentDoc,
} from '../../graphql/api/generated';
import { useMainApiTableData } from '../../hooks/useTableManager';
import { createdAtColumn, updatedAtAndByColumn } from '../common/columns';
import { getDescriptionsFromColumns } from '../helpers/getDescriptionsFromColumns';
import type { IModelTableExpandable } from '../typings';

import * as actions from './actions';
import * as columns from './columns';
import model from './model';

const description = () => {
  return (
    <>
      Vendors can scan a Smart Sign and enter their assigned passcode in the web app to start unlocking access points at the property.
    </>
  );
};

export const expandable: IModelTableExpandable<VendorPasscodeTableFragment> = {
  rowExpandable: ({ createdAt, updatedAt }) => updatedAt !== createdAt,
  expandedRowRender: (row) => {
    const descriptions = getDescriptionsFromColumns(row, [updatedAtAndByColumn]);

    return <TableCellDescriptions descriptions={descriptions} />;
  },
};

model.actions.setDefaultActions([actions.regenerateAction]);

const commonTableConfig = {
  description,
  expandable,
  useTableData: useMainApiTableData({
    totalOperation: getVendorPasscodesTotalDocument,
    listOperation: getVendorPasscodesDocument,
  }),
  fragment: VendorPasscodeTableFragmentDoc, // @TODO: Not used, but required by config
};

const commonColumns = [
  columns.codeColumn,
  columns.codeWithRecommendationColumn,
  columns.createdByColumn,
  createdAtColumn,
];

export const VendorPasscodesMainTable = model.createTable<VendorPasscodeTableFragment>({
  ...commonTableConfig,
  columns: [
    columns.propertiesColumn,
    columns.assignedToColumn,
    ...commonColumns,
  ],
});

export const VendorPasscodesByPropertyTable = model.createTable<VendorPasscodeTableFragment, string>({
  ...commonTableConfig,
  fixedQueryFilters: propertyId => ({ propertyId }),
  columns: [
    columns.assignedToColumn,
    ...commonColumns,
  ],
  fetchPolicy: 'cache-first',
});


export const VendorPasscodesByUserTable = model.createTable<VendorPasscodeTableFragment, string>({
  ...commonTableConfig,
  title: 'Vendor Passcode',
  fixedQueryFilters: userId => ({ assignedToUserId: userId }),
  columns: [
    columns.propertiesColumn,
    ...commonColumns,
  ],
  fetchPolicy: 'cache-first',
});
